import NBType, { InferType } from '@netbase/nb-type'
import MediaType from '../enums/MediaType'

const RichMentionedUrlSchema = NBType.object().shape('RichMentionedUrlSchema', {
  /* @prop */
  displayUrl: NBType.string().nullable(),
  /* @prop */
  expandedUrl: NBType.array().of(NBType.string()).nullable(),
  /* @prop */
  mediaType: NBType.enum(MediaType).nullable(),
  /* @prop */
  mediaUrl: NBType.string().nullable(),
  /* @prop */
  supportedVideo: NBType.boolean(),
  /* @prop */
  thumbnailUrl: NBType.string().nullable(),
  /* @prop */
  url: NBType.string().nullable()
  /* END */
})
export default RichMentionedUrlSchema
export type RichMentionedUrl = InferType<typeof RichMentionedUrlSchema>
// RESERVE BELOW
